import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { imageEditorActions } from "../../../store/imageEditor";

export default function UploadMaskButton() {

  const dispatch = useDispatch();

  const handleMaskUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // Create an offscreen canvas just for processing
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0);

        // Process pixels: fully opaque → white, others → transparent
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];

          if (alpha === 255) {
            // Fully opaque pixel → white
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            data[i + 3] = 255;
          } else {
            // Any non-opaque pixel → fully transparent
            data[i + 3] = 0;
          }
        }

        ctx.putImageData(imageData, 0, 0);

        // Get cleaned mask as base64 PNG
        const mask64 = canvas.toDataURL("image/png");

        // Dispatch to redux
        dispatch(imageEditorActions.setMask(mask64));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  return (
    <Button variant="outlined" component="label"
      startIcon={<FileUploadIcon />}
    >
      Upload Mask
      <input
        type="file"
        accept="image/png"
        hidden
        onChange={handleMaskUpload}
      />
    </Button>
  );
}
